import { render, staticRenderFns } from "./data-chart-card.vue?vue&type=template&id=01030db6&scoped=true&"
import script from "./data-chart-card.vue?vue&type=script&lang=js&"
export * from "./data-chart-card.vue?vue&type=script&lang=js&"
import style0 from "./data-chart-card.vue?vue&type=style&index=0&id=01030db6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01030db6",
  null
  
)

export default component.exports